import { render } from "./WaterControl.vue?vue&type=template&id=060a863c"
import script from "./WaterControl.vue?vue&type=script&lang=js"
export * from "./WaterControl.vue?vue&type=script&lang=js"

import "./WaterControl.vue?vue&type=style&index=0&id=060a863c&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__